import { AppDefinition } from '../../types/apps';

export const PasswordVaultAppDefinition: AppDefinition = {
  appId: 'password-vault',
  name: 'Password Vault',
  version: '1.0.0',
  description: 'Secure credential manager for logins, payment cards, identities, secure notes, and API keys',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Vault',
    phosphorWeight: 'duotone',
    color: '#d97706',
  },
  supportedFileTypes: [],
  entityTypes: ['Credential'],
  component: 'PasswordVaultApp',
  requiresProps: false,
  requiresEntity: false,
  actions: {},
  experimental: true,
};
